import { Component, ElementRef, Input, Renderer2, ViewEncapsulation } from '@angular/core';
import { NavbarVerticalStyle1Component } from './vertical/style-1/style-1.component';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NavbarVerticalStyle1Component]
})
export class NavbarComponent
{
    // Private
    variants: string;

    /**
     * Constructor
     *
     * @param {ElementRef} elementRef
     * @param {Renderer2} renderer
     */
    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2
    )
    {
        // Set the private defaults
        this.variants = 'vertical-style-1';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Variant
     */
    get variant(): string
    {
        return this.variants;
    }

    @Input()
    set variant(value: string)
    {
        // Remove the old class name
        this.renderer.removeClass(this.elementRef.nativeElement, this.variant);

        // Store the variant value
        this.variants = value;

        // Add the new class name
        this.renderer.addClass(this.elementRef.nativeElement, value);
    }
}
